<div
  [class]="containerClasses()"
  class="group flex flex-col flex-nowrap items-start justify-start h-fit w-fit pb-1"
>
  <span
    [class]="labelClasses()"
    class="flex flex-row flex-wrap items-start justify-start h-fit w-fit text-base font-semibold tracking-normal leading-5 text-left"
  >
    {{ label() }}
  </span>
</div>
